











import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { CreatorsListTab, CreatorsTabsEnum } from "../../types";

export default defineComponent({
  name: "CreatorsListTabs",
  props: {
    activeTab: { type: String as () => CreatorsTabsEnum, default: CreatorsTabsEnum.ALL },
    total: { type: Object as () => Record<CreatorsTabsEnum, number>, required: true },
    showTotal: { type: Boolean, default: false },
  },
  setup(props) {
    const tabs = computed<Array<CreatorsListTab & { total: number }>>(() => [
      {
        name: $t("All"),
        value: CreatorsTabsEnum.ALL,
        to: "/creators",
        total: props.total[CreatorsTabsEnum.ALL],
      },
      {
        name: $t("Online"),
        value: CreatorsTabsEnum.ONLINE,
        to: "/creators/online",
        total: props.total[CreatorsTabsEnum.ONLINE],
      },
      {
        name: $t("Live"),
        value: CreatorsTabsEnum.LIVE,
        to: "/creators/live",
        total: props.total[CreatorsTabsEnum.LIVE],
      },
    ]);
    return { tabs };
  },
});
